<div class="sidebar scrollbar" [class.open]="sidebarOpen">
  <app-sidebar-image-filter
    *ngIf="filterList && filterList?.length > 0"
    [baseFolderKey]="baseFolderKey"
    [filterList]="filterList"
    [defaultFilterKey]="defaultFilterKey"
    (filterClicked)="onClickFilter($event)"
  ></app-sidebar-image-filter>
</div>
